import type { ReactNode } from 'react';

export const PublicLayout = ({ children }: { children: ReactNode }) => {
  return children;
};
